import { FaPlus, FaRegFile, FaRegCalendarAlt, FaRegCalendarCheck, FaUserClock, FaSuitcase } from 'react-icons/fa';
import { getUserInfo } from 'utils/auth';

interface IProps {
  shouldSeeLeaves: boolean;
  isLeavesRoute: boolean;
  shouldSeeColleaguesLeaves: boolean;
  shouldSeeHourlyAbsences: boolean;
  shouldSeeWorkTrips: boolean;
  t: (text: string) => void;
}

export const getClientEmployeeMenuItems = ({
  shouldSeeLeaves,
  isLeavesRoute,
  shouldSeeColleaguesLeaves,
  shouldSeeHourlyAbsences,
  shouldSeeWorkTrips,
  t,
}: IProps) => {
  const isMobile = window.innerWidth < 992;
  const userInfo = getUserInfo();
  const { isCandidate } = userInfo;
  const menuItems = [];

  // If user is a candidate, only show create document and my documents
  if (isCandidate) {
    menuItems.push({
      label: 'menu.createDocument',
      icon: FaPlus,
      to: '/documents-wizard/step-1',
      type: 'button',
    });
    menuItems.push({
      label: 'menu.myDocuments',
      icon: FaRegFile,
      to: '/my-documents/received',
    });
    return menuItems;
  }

  if (isMobile) {
    // Mobile-specific order
    menuItems.push({
      label: 'menu.createDocument',
      icon: FaPlus,
      to: '/documents-wizard/step-1',
      type: 'button',
    });
    menuItems.push({
      label: 'menu.myDocuments',
      icon: FaRegFile,
      to: '/my-documents/received',
    });

    if (shouldSeeLeaves) {
      menuItems.push({
        label: `${t('leaves.requestLeave')}`,
        icon: FaPlus,
        to: '/my-leaves/create',
        type: 'button',
      });
      if (!shouldSeeColleaguesLeaves) {
        menuItems.push({
          label: 'menu.leaves',
          icon: FaRegCalendarAlt,
          to: '/my-leaves',
        });
      }
    }
  } else {
    // Default order for non-mobile devices
    menuItems.push(
      {
        label: 'menu.createDocument',
        icon: FaPlus,
        to: '/documents-wizard/step-1',
        type: 'button',
      },
      {
        label: 'menu.myDocuments',
        icon: FaRegFile,
        to: '/my-documents/received',
      }
    );

    if (shouldSeeLeaves && !isLeavesRoute) {
      menuItems.splice(1, 0, {
        label: `${t('leaves.requestLeave')}`,
        icon: FaPlus,
        to: '/my-leaves/create',
        type: 'button',
      });
    }

    if (shouldSeeLeaves && !shouldSeeColleaguesLeaves) {
      menuItems.push({
        label: 'menu.leaves',
        icon: FaRegCalendarAlt,
        to: '/my-leaves',
      });
    }
  }

  if (shouldSeeColleaguesLeaves) {
    menuItems.push({
      label: `${t('menu.colleaguesLeaves')}`,
      icon: FaRegCalendarCheck,
      to: '/colleague-leaves',
    });
    menuItems.push({
      label: `${t('menu.myLeaves')}`,
      icon: FaRegCalendarAlt,
      to: '/my-leaves',
    });
  }

  if (shouldSeeHourlyAbsences) {
    menuItems.push({
      label: 'menu.hourlyAbsences',
      icon: FaUserClock,
      to: '/my-hourly-absences',
    });
  }

  if (shouldSeeWorkTrips) {
    menuItems.push({
      label: 'menu.workTrips',
      icon: FaSuitcase,
      to: '/my-work-trips',
    });
  }

  return menuItems;
};

export default getClientEmployeeMenuItems;
